export default "__VITE_ASSET__CiAia6rm__"